<page-headline
    [linkTitle]="'My Vision'"
    [module]="'my-vision'"
    [moduleIcon]="'fa-star'"
    [pageTitle]="pageTitle"
    [moduleLink]="'my-vision'"
>
</page-headline>

<main-filters (filtersOutput)="applyNewFilters($event)"></main-filters>
<div class="displayopt-actionpanel-layout">
    <display-options (displayOptionsOutput)="applyDisplayOptions($event)"> </display-options>
    <action-panel
        [showExportCsv]="false"
        [showSaveAsPdf]="true"
        [showPrint]="false"
        [title]="pageTitle"
    >
    </action-panel>
</div>
<div class="custom-dashboard-container">
    <div *ngFor="let track of tracks; let i = index">
        <div
            class="custom-dashboard-track"
            dragula="{{ track.group }}"
            [dragulaModel]="track.cardsIdArray"
            (dragulaModelChange)="dragWidget($event, i)"
        >
            <div
                id="custom-dashboard-widget___{{ cardId }}___"
                *ngFor="let cardId of track.cardsIdArray"
                class="custom-dashboard-widget {{ track.class }}"
            >
                <div class="custom-dashboard-card">
                    <ng-template customDashboardsOutlet [item]="cardId"></ng-template>
                </div>
            </div>
        </div>
    </div>
</div>
